import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';

export type AddFavoriteListingCall = (
  listingId: number,
) => Promise<{ data: FavoriteListing }>;

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('POST', `/api/v2/listing/${listingId}/favorite`);
